/**
 * Price Format Fixer
 * Converts European price format (1.499,00) to US/UK format (1,499.00)
 */

(function() {
  'use strict';

  function formatPrice(priceText) {
    // Check if the price uses European format (dot for thousands, comma for decimals)
    // Pattern: €1.499,00 or 1.499,00€
    
    // Match prices with dot as thousand separator and comma as decimal separator
    const europeanPattern = /([€$£¥]?\s*)(\d{1,3})\.(\d{3}),(\d{2})(\s*[€$£¥]?)/g;
    
    return priceText.replace(europeanPattern, function(match, prefix, thousands, hundreds, cents, suffix) {
      // Convert to US/UK format: 1,499.00
      return prefix + thousands + ',' + hundreds + '.' + cents + suffix;
    });
  }

  function fixPricesOnPage() {
    // Find all elements that typically contain prices
    const priceSelectors = [
      '.price',
      '.product__price',
      '.price__regular',
      '.price__sale',
      '.price-item',
      '[class*="price"]',
      '.money',
      '.product-price',
      '.variant-price',
      '.cart__price',
      '.total-price'
    ];

    const priceElements = document.querySelectorAll(priceSelectors.join(','));

    priceElements.forEach(element => {
      // Get all text nodes and fix their content
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      const nodesToFix = [];
      let node;
      
      while (node = walker.nextNode()) {
        if (node.nodeValue && node.nodeValue.match(/\d\.\d{3},\d{2}/)) {
          nodesToFix.push(node);
        }
      }

      nodesToFix.forEach(textNode => {
        textNode.nodeValue = formatPrice(textNode.nodeValue);
      });
    });

    console.log('✅ Fixed', priceElements.length, 'price elements');
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixPricesOnPage);
  } else {
    fixPricesOnPage();
  }

  // Re-run when prices might update dynamically (variant changes, AJAX, etc.)
  const observer = new MutationObserver(function(mutations) {
    let shouldRefix = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const target = mutation.target;
        if (target.textContent && target.textContent.match(/[€$£¥]/)) {
          shouldRefix = true;
        }
      }
    });

    if (shouldRefix) {
      fixPricesOnPage();
    }
  });

  // Observe the entire document for price changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // Also listen for Shopify's variant change events
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function() {
      setTimeout(fixPricesOnPage, 100);
    });
  }

})();
